(function () {
  'use strict';
  var mounted = new WeakSet();
  var artworkMounted = new WeakSet();
  var source = document.querySelector('script[data-crate-loader]');
  var route = source ? source.dataset.rootUrl || '/' : window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  // Keep recommendation feedback separate from the legacy 700ms player tap effect.
  var pressedListen = null;
  var pendingListen = null;
  function releaseListenPress() {
    if (pressedListen) pressedListen.classList.remove('cchw-crate-pressed');
    pressedListen = null;
  }
  function finishListen() {
    if (!pendingListen) return;
    var pending = pendingListen;pendingListen = null;
    pending.observer.disconnect();clearTimeout(pending.timer);
    pending.button.classList.remove('cchw-crate-buffering','cchw-player-triggered','is-loading-track');
    pending.button.removeAttribute('aria-busy');pending.button.removeAttribute('aria-disabled');
  }
  function watchListen(button) {
    var player = document.querySelector('.cchw-player-wrapper');
    var firstTrack = button.parentElement.querySelector('.archive-playlist span[data-src]');
    if (!player || !firstTrack) return;
    var pending = {button:button,title:firstTrack.dataset.track || ''};
    pendingListen = pending;
    button.classList.add('cchw-crate-buffering');button.setAttribute('aria-busy','true');button.setAttribute('aria-disabled','true');
    function checkPlayback() {
      if (pendingListen !== pending) return;
      var title = player.querySelector('#cchw-player-currently-playing-title');
      var playing = player.querySelector('button[aria-label="Pause"]:not([disabled])');
      if (!button.isConnected || (playing && title && title.textContent.trim() === pending.title.trim())) finishListen();
    }
    pending.observer = new MutationObserver(checkPlayback);
    pending.observer.observe(player,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['aria-label','disabled']});
    // Recover the control if playback never starts; the player remains responsible for audio.
    pending.timer = setTimeout(function () { if (pendingListen === pending) finishListen(); },15000);
    setTimeout(checkPlayback,0);
  }
  window.addEventListener('pointerdown',function (event) {
    releaseListenPress();
    var button = event.target.closest('[data-crate-listen]');if (!button || button.disabled) return;
    var touch = event.pointerType === 'touch' || event.pointerType === 'pen';
    button.classList.toggle('cchw-crate-touch',touch);
    if (touch) { pressedListen=button;button.classList.add('cchw-crate-pressed'); }
  },{passive:true});
  window.addEventListener('pointerup',releaseListenPress,{passive:true});
  window.addEventListener('pointercancel',releaseListenPress,{passive:true});
  window.addEventListener('blur',releaseListenPress);
  window.addEventListener('pointerover',function (event) {
    if (event.pointerType !== 'mouse') return;
    var button=event.target.closest('[data-crate-listen]');
    if (button) button.classList.remove('cchw-crate-touch','cchw-crate-pressed');
  },{passive:true});
  // Capture ahead of the shared player handler, retaining the original native tap.
  window.addEventListener('click',function (event) {
    var button=event.target.closest('[data-crate-listen]');
    if (!button) {
      if (event.target.closest('.player-addplaylist,.player-playtrack-button,.product-details__player-addplaylist')) finishListen();
      return;
    }
    if (pendingListen && pendingListen.button === button) { event.preventDefault();event.stopPropagation();return; }
    finishListen();
    if (!button.disabled && button.classList.contains('player-addplaylist')) watchListen(button);
  },true);
  var audio = new Map();
  var recent = [];
  try { recent = JSON.parse(sessionStorage.getItem('cchw-crate-recent') || '[]'); } catch (error) {}
  function read(node) { return JSON.parse(node.textContent); }
  function escape(value) { return String(value || '').replace(/[&<>"']/g, function (c) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function request(url, options) {
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 15000);
    return fetch(url, Object.assign({credentials:'same-origin',headers:{Accept:'application/json'},signal:controller.signal}, options)).then(function (response) {
      return response.json().then(function (data) { if (!response.ok) throw new Error(data.description || data.message || 'Request failed'); return data; });
    }).finally(function () { clearTimeout(timer); });
  }
  function normalize(values) { return Array.from(new Set(values.flat().map(function (v) { return String(v).trim().toLowerCase(); }).filter(Boolean))); }
  function rank(records, styles, excluded, groups) {
    var broad = new Set(['house','techno','electro','disco','jazz','funk','ambient','electronic','electronica']);
    var ranked = records.filter(function (r) { return !excluded.has(r.id) && r.limit !== 0; }).map(function (r) {
      var matched = normalize(r.styles).filter(function (style) { return styles.includes(style); });
      var score = matched.reduce(function (sum, style) { return sum + (broad.has(style) ? 1 : 3); }, 0);
      return Object.assign({}, r, {matched:matched,score:score * 1000 - (recent.includes(r.id) ? 250 : 0) + Math.random() * 200});
    }).sort(function (a,b) { return b.score - a.score; });
    var queues = (groups || []).map(function (group) {
      var ids = new Set(group.ids);
      return ranked.filter(function (record) { return ids.has(record.id); });
    }).filter(function (queue) { return queue.length; });
    if (queues.length < 2) return ranked;
    queues.sort(function (a,b) { return b[0].score - a[0].score; });
    var mixed = [], used = new Set();
    while (queues.some(function (queue) { return queue.length; })) {
      queues.forEach(function (queue) {
        while (queue.length && used.has(queue[0].id)) queue.shift();
        if (!queue.length) return;
        var record = queue.shift();used.add(record.id);mixed.push(record);
      });
    }
    return mixed;
  }
  function audioData(record) {
    if (Array.isArray(record.tracks)) return Promise.resolve(record);
    if (!audio.has(record.id)) audio.set(record.id,request(record.url + '?view=cchw-audio-json',{headers:{Accept:'text/html'}}).then(function (data) {
      if (!Array.isArray(data.tracks) || !data.tracks.length) throw new Error('Preview unavailable');
      return data;
    }).catch(function (error) { audio.delete(record.id);throw error; }));
    return audio.get(record.id);
  }
  function attachAudio(record, button, data) {
    if (!button.isConnected || button.classList.contains('player-addplaylist')) return;
    var archive = button.parentElement.querySelector('.archive-playlist');
    if (!data.tracks.length) { button.disabled=true;button.title='No audio preview available';return; }
    data.tracks.forEach(function (track) {
      var span = document.createElement('span');
      span.dataset.src=track.url || track[0];span.dataset.track=track.title || track[1];span.dataset.img=track.artworkUrl||record.image||'';span.dataset.producturl=track.productUrl||record.url;archive.appendChild(span);
    });
    button.dataset.artist=data.vendor||'';button.dataset.img=data.featuredImage||record.image||'';button.classList.add('player-addplaylist');
  }
  function prepareAudio(record, button, text) {
    button.disabled=true;button.setAttribute('aria-busy','true');button.classList.add('is-loading-track');
    return audioData(record).then(function (data) {
      attachAudio(record,button,data);
      button.disabled=false;button.removeAttribute('aria-busy');button.classList.remove('is-loading-track');
      if (button.isConnected) button.click();
    }).catch(function (error) {
      button.disabled=false;button.removeAttribute('aria-busy');button.classList.remove('is-loading-track');button.querySelector('[data-crate-listen-label]').textContent=text.retry;throw error;
    });
  }
  function mount() {
    document.querySelectorAll('[data-crate-enlarge]').forEach(function (button) {
      if (artworkMounted.has(button)) return;
      var dialog = button.closest('.product-page__image-playlist-container').querySelector('[data-crate-art-dialog]');
      if (!dialog) return;
      artworkMounted.add(button);
      button.addEventListener('click',function () { var image=dialog.querySelector('[data-crate-zoom-image]');if(!image.src)image.src=image.dataset.src;dialog.showModal(); });
      dialog.querySelector('[data-crate-close]').addEventListener('click',function () { dialog.close(); });
    });
    document.querySelectorAll('[data-crate-recs]').forEach(function (root) {
    if (mounted.has(root)) return;
    var configNode = root.querySelector('[data-crate-config]');
    if (!configNode || !configNode.textContent.trim()) return;
    try { read(configNode); } catch (error) { return; }
    mounted.add(root);
    var config = read(root.querySelector('[data-crate-config]'));
    var text = config.text;
    var excluded = new Set(config.exclude);
    var styles = normalize(config.styles);
    var ranked = [], picks = [], page = 0, selected = new Set(), loaded = false, adding = false, uncertain = false;
    var cards = root.querySelector('[data-crate-cards]');
    var status = root.querySelector('[data-crate-status]');
    var add = root.querySelector('[data-crate-add]');
    var warmedImages = new Set();
        var money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency',currency:config.currency});
    function amount(pence) { return money.format(pence / 100); }
    function bundle() {
      var chosen = picks.filter(function (r) { return selected.has(r.id); });
      root.querySelector('[data-crate-selection]').textContent = chosen.length ? text.selected.replace('__COUNT__',chosen.length) : text.none;
      root.querySelector('[data-crate-total]').textContent = amount(chosen.reduce(function (sum,r) { return sum+r.price; },0));
      add.disabled = adding || uncertain || !chosen.length;
    }
    function render(preserveVisible) {
      page = Math.min(page,Math.max(0,Math.ceil(picks.length/3)-1));
      var visible = picks.slice(page*3,page*3+3);
      if (!preserveVisible) {
      if (pendingListen && root.contains(pendingListen.button)) finishListen();
      cards.replaceChildren();
      visible.forEach(function (r) {
        var article = document.createElement('article');article.className = 'cchw-crate-pick';
        var match = r.matched.length ? text.matched + ': ' + r.matched.map(function (s) { return s.charAt(0).toUpperCase()+s.slice(1); }).join(', ') : '';
        article.innerHTML = '<a class="cchw-crate-pick__art" href="'+escape(r.url)+'">'+(r.image?'<img src="'+escape(r.image)+'" alt="'+escape(r.title)+'" width="80" height="80" loading="eager" decoding="async">':'')+'</a><div class="cchw-crate-pick__body">'+(r.preorder?'<strong class="cchw-crate-preorder">'+escape(text.preorder)+'</strong>':'')+'<h3><a href="'+escape(r.url)+'">'+escape(r.title)+'</a></h3>'+(r.preorder?'<p class="cchw-crate-later">'+escape(text.shipsLater)+'</p>':'')+(match?'<p class="cchw-crate-match">'+escape(match)+'</p>':'')+'<p class="cchw-crate-price">'+escape(amount(r.price))+(r.taxable?'<small>('+escape(amount(Math.round(r.price*config.taxMultiplier)))+' '+escape(text.inclVat)+')</small>':'')+'</p></div><div class="cchw-crate-pick__actions"><button type="button" class="cchw-crate-control cchw-crate-listen" data-crate-listen="'+r.id+'"><span aria-hidden="true" data-crate-play-icon>▷</span><svg aria-hidden="true" class="cchw-crate-record-icon" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="currentColor"/><circle cx="12" cy="12" r="2.5"/><path d="M12 5a7 7 0 0 1 7 7M5 12a7 7 0 0 0 7 7" fill="none" stroke-width="1.5"/></svg><span data-crate-listen-label>'+escape(text.listen)+'</span></button><span class="archive-playlist display-none"></span><label class="cchw-crate-include"><input type="checkbox" data-crate-include="'+r.id+'" '+(selected.has(r.id)?'checked':'')+' aria-label="'+escape(text.include+' '+r.title+(r.preorder?' — '+text.preorder:''))+'">'+escape(text.include)+'</label></div>';
        cards.appendChild(article);
        var listen = article.querySelector('[data-crate-listen]');
        if (Array.isArray(r.tracks)) attachAudio(r,listen,r);
        else if (audio.has(r.id)) audioData(r).then(function (data) { attachAudio(r,listen,data); }).catch(function () {});
      });
      }
      // Warm only the next three small thumbnails, without requesting any music.
      picks.slice((page+1)*3,(page+2)*3).forEach(function (r) {
        if (!r.image || warmedImages.has(r.image)) return;
        warmedImages.add(r.image);var image=new Image();image.decoding='async';image.src=r.image;
      });
      cards.setAttribute('aria-busy','false');
      root.querySelector('[data-crate-pager]').hidden = !picks.length;
      root.querySelector('[data-crate-bundle]').hidden = !picks.length;
      root.querySelector('[data-crate-prev]').disabled = page === 0 || adding;
      root.querySelector('[data-crate-next]').disabled = (page+1)*3 >= picks.length || adding;
      root.querySelector('[data-crate-page]').textContent = text.page.replace('__START__',page*3+1).replace('__END__',Math.min(picks.length,page*3+3)).replace('__TOTAL__',picks.length);
      bundle();
    }
    function reconcile(cart) {
      (cart.items || []).forEach(function (item) { excluded.add(item.product_id);selected.delete(item.product_id); });
      if (root.dataset.crateRecs === 'cart') {
        var cartIds = new Set((cart.items || []).map(function (item) { return item.product_id; }));
        var activeGroups = (config.groups || []).filter(function (group) {
          return (group.contextIds || []).some(function (id) { return cartIds.has(id); });
        });
        var eligible = new Set(activeGroups.flatMap(function (group) { return group.ids; }));
        ranked = rank(config.records.filter(function (record) { return eligible.has(record.id); }),styles,excluded,activeGroups);
      }
      picks = ranked.filter(function (r) { return !excluded.has(r.id); }).slice(0,12);
      render();
    }
    function load() {
      if (loaded) return;
      loaded = true;status.textContent = root.dataset.loadingText;
      ranked = rank(config.records || [],styles,excluded,config.groups);
      picks = ranked.slice(0,12);
      render();status.textContent = picks.length ? '' : text.empty;
      recent = picks.map(function (r) { return r.id; }).concat(recent).slice(0,48);
      try { sessionStorage.setItem('cchw-crate-recent',JSON.stringify(recent)); } catch (error) {}
    }

    root.dataset.loadingText = status.textContent;
    root.addEventListener('change',function (event) {
      if (!event.target.matches('[data-crate-include]')) return;
      var id = Number(event.target.dataset.crateInclude);event.target.checked ? selected.add(id) : selected.delete(id);bundle();
    });
    root.addEventListener('click',function (event) {
      var button = event.target.closest('button');if (!button || button.disabled) return;
      if (button.hasAttribute('data-crate-prev')) { page--;render(); }
      if (button.hasAttribute('data-crate-next')) { page++;render(); }
      if (button.hasAttribute('data-crate-listen') && !button.classList.contains('player-addplaylist')) {
        var record = picks.find(function (r) { return r.id === Number(button.dataset.crateListen); });
        prepareAudio(record,button,text).catch(function (error) { status.textContent = error.message || text.previewUnavailable; });
      }
    });
    root.addEventListener('pointerover',function (event) {
      if (event.pointerType !== 'mouse') return;
      var button=event.target.closest('[data-crate-listen]');if(!button)return;
      var record=picks.find(function(r){return r.id===Number(button.dataset.crateListen);});
      audioData(record).then(function(data){attachAudio(record,button,data);}).catch(function(){});
    });
    root.addEventListener('focusin',function(event){
      var button=event.target.closest('[data-crate-listen]');if(!button)return;
      var record=picks.find(function(r){return r.id===Number(button.dataset.crateListen);});
      audioData(record).then(function(data){attachAudio(record,button,data);}).catch(function(){});
    });
    var start;
    cards.addEventListener('touchstart',function (event) { start = event.target.closest('button,input,label,a') ? null : {x:event.touches[0].clientX,y:event.touches[0].clientY}; },{passive:true});
    cards.addEventListener('touchend',function (event) { if (!start) return;var dx=event.changedTouches[0].clientX-start.x,dy=event.changedTouches[0].clientY-start.y;start=null;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.5){var button=root.querySelector(dx<0?'[data-crate-next]':'[data-crate-prev]');if(!button.disabled)button.click();} },{passive:true});
    cards.addEventListener('touchcancel',function () { start=null; },{passive:true});
    add.addEventListener('click',function () {
      var chosen = picks.filter(function (r) { return selected.has(r.id); });
      if (!chosen.length || adding || uncertain) return;
      adding = true;add.textContent = text.adding;add.setAttribute('aria-busy','true');bundle();
      request(route+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:chosen.map(function (r) { return {id:r.variant,quantity:1}; })})}).then(function () {
        return request(route+'cart.js').then(function (cart) {
          selected.clear();document.dispatchEvent(new CustomEvent('cchw:cart-updated',{detail:{cart:cart}}));
          document.querySelectorAll('.cartCount').forEach(function (node) { node.textContent=cart.item_count;node.classList.toggle('hidden-count',cart.item_count<1); });
          status.textContent = '✓ '+text.added;
          if (root.dataset.crateRecs === 'cart') window.location.reload();
        });
      }).catch(function (error) {
        status.textContent = error.name === 'AbortError' ? text.error : error.message || text.error;
        return request(route+'cart.js').then(reconcile).catch(function () { uncertain=true;status.textContent=text.checkCart; });
      }).finally(function () { adding=false;add.textContent=text.addSelected;add.removeAttribute('aria-busy');bundle();root.querySelector('[data-crate-prev]').disabled=page===0;root.querySelector('[data-crate-next]').disabled=(page+1)*3>=picks.length; });
    });
    document.addEventListener('cchw:cart-updated',function (event) { if (event.detail && event.detail.cart && ranked.length) reconcile(event.detail.cart); });
    load();
    });
  }
  document.addEventListener('cchw:crate-ready',mount);
  document.addEventListener('DOMContentLoaded',mount,{once:true});
  mount();
})();
